import 'javascripts/jquery-ui/dialog'
import 'parsleyjs'
import { autogrow } from 'javascripts/general_scripts'
import { modalRestrictedUser } from "javascripts/modal_itcs"
import { user } from 'javascripts/gitb_autocomplete'
import 'javascripts/redactor'
import 'javascripts/user_tagging.js'
import { userSlugFromAnchor, userTaggingMarkup } from './user_tagging_utils'

/* stylesheet */
import 'stylesheets/redactor.min'

autogrow();
modalRestrictedUser();
user();

// sometimes each comment is in its own container, sometimes it shares a container with other comments
// This method allows us to insert the new reply after the last adjacent reply, or after the form
window.gLastMatchingElement = (startingElement, selector) => {
  if (startingElement.nextElementSibling?.matches(selector)) {
    return gLastMatchingElement(startingElement.nextElementSibling, selector);
  }
  return startingElement;
}

$R('#comment-body-form textarea', { toolbar: false });
let replyFormTemplate = document.querySelector('#replies-form-template');
$(document).on('click', '.open-reply-form', function(e) {
    e.preventDefault();
    let { replyId } = this.dataset;
    let commentContainer = (replyId == null) ? (this.closest('.embedded-comment') ||  this.closest('.embedded-comment-2')): document.querySelector(`#reply-${replyId}-container`);
    if (this.classList.contains('open')) {
        if(this.closest('.embedded-comment')) {
            if (commentContainer.nextSibling.matches('.replies-form-template')) commentContainer.nextSibling.remove();
        } else {
            $(commentContainer).find('.embedded-comment-form').remove();
        }
        this.classList.remove('open');
    } else {
        let { token, commentId, userName } = this.dataset
        let formId = `reply-form-${commentId}`;
        let newForm = replyFormTemplate.content.cloneNode(true).firstChild;
        let userSlug = userSlugFromAnchor(commentContainer.querySelector('.author-info'));
        let tagLink = `${userTaggingMarkup(userSlug, userName)}<span>&nbsp;</span>`;
        if(this.closest('.embedded-comment')) {
            commentContainer.after(newForm);
            newForm.id = formId;
        } else {
            $(commentContainer).append(newForm);
            newForm.querySelector('form').id = formId;
        }
        newForm.querySelector('[name="authenticity_token"]').value = token;
        newForm.querySelector('[name="reply[comment_id]"]').value = commentId;
        $R(newForm.querySelector('textarea'), { toolbar: false, focusEnd: true }).source.setCode(tagLink);
        this.classList.add('open');
        $(newForm).find('form').parsley().reset();
    }
});

$('body').on('click', '.cancel-reply', function() {
    let parent = $(this).parents('.embedded-comment-form');
    parent.siblings('.comment-footer').find('.open-reply-form').removeClass('open');
    parent.siblings('.open-reply-form').removeClass('open');
    parent.remove();
});

$('body').on('submit', '#comment-body-form, .replies-form-template', (e) => {
    const form = $(e.target);
    if (form.data('recaptcha-validated')) { return; }
    e.preventDefault();
    e.stopImmediatePropagation();

    // extract captcha_action from the form
    const captcha_action = form.find('.captcha-line').find('input').attr("name")?.replace('g-recaptcha-response-data[', '')?.replace(']', '');

    // Using whenValid() which returns a promise
    form.parsley().whenValid().then(function() {
        $.ajax({
            url: '/recaptcha',
            type: 'POST',
            dataType: 'json',
            data: form.serialize() + "&captcha_action=" + captcha_action, // we pass the whole form to the server because it contains the recaptcha response for both v3 and v2
            success(result, status, data) {
                form.data('recaptcha-validated', true);
                $.ajax({
                    type: form.attr('method'),
                    url: form.attr('action'),
                    data: form.serialize(),
                    dataType: 'script',
                    error: function(xhr) {
                        form.find('input[type="submit"]').prop('disabled', false);
                    },
                    success: function() {
                        // hide captcha after successful submission
                        form.find('.captcha-line').html('');
                    }
                });
            },
            error(result, status, data) {
                form.find('input[type="submit"]').prop('disabled', false);
                form.find('.captcha-line').html(result.responseJSON.captcha_html);
            }
        });
    }).fail(function() {
        form.find('input[type="submit"]').prop('disabled', false);
    });
});

$(document).on('click', '.edit-reply', function(e) {
    e.preventDefault();

    let commentContainer = this.closest('.embedded-comment') || this.closest('.embedded-comment-2');
    if (this.classList.contains('open')) {
        if (commentContainer.nextSibling.matches('.replies-form-template')) commentContainer.nextSibling.remove();
        this.classList.remove('open')
    } else {
        let {commentId, action, replyId} = this.dataset;
        document.querySelector(`.open-reply-form[data-reply-id="${replyId}"]`).click();
        // let form = document.querySelector(`#reply-form-${commentId}`);
        let form = this.closest('.embedded-comment') ? commentContainer.nextSibling : commentContainer.querySelector('form');
        form.setAttribute('action', action);
        form.querySelector('[name="_method"]').value = 'patch';
        let redactor = $R(form.querySelector('textarea'));
        redactor.insertion.set(this.closest('.embedded-comment') ? commentContainer.querySelector('.the-rest').innerHTML : commentContainer.querySelector('.the-rest p').innerHTML.replace(/\r?\n/g, ''));
        if(this.closest('.embedded-comment')) {
            $(`.open-reply-form[data-reply-id="${replyId}"]`).removeClass('open');
            this.classList.add('open');
        }
    }
});

var hash = location.hash.slice(1);
if(hash.includes('reply')) {
    let replyId = hash.replace('reply','');
    document.querySelector(`.open-reply-form[data-reply-id="${replyId}"]`).click();
}

// if (dataLayer[0].adminUser) {
//   import('javascripts/content_taggings')
// }

$('body').on('click', '.cancel-comment', function() {
    let form = $(this).parents('form');
    form.find('.redactor-styles').html('');
    form.find('.errors-box').html('');
    form.parsley().reset();
    $(this).blur();
    // $('.open-reply-form').removeClass('open');
    // form.parent().siblings('.comment-footer .open-reply-form').removeClass('open');
});

$('body').on('click', '.submit-comment', function() {
    $(this).parents('form').find('.redactor-styles').focus();
});

$('body').on('click', '.show-all-comments', function() {
    $(this).parent().find('.loading').show();
});

$R('.reply-form-inline textarea', { toolbar: false });

$('body').on('keyup', '.redactor-styles', function() {
    //  fix: bug - parsley not working if the user removes the auto-tagging and .redactor-styles contains '<p><br></p>'
    if($R(this.nextSibling).editor.isEmpty()) $(this).html('');
});
